if (window.__bonusBadgeInitialized) {
  // Already initialized by a previous script load; no-op to avoid duplicated work.
} else {
  window.__bonusBadgeInitialized = true;

  if (!customElements.get("bonus-badge")) {
    customElements.define(
      "bonus-badge",
      class BonusBadge extends HTMLElement {
        constructor() {
          super();
          this.attachShadow({ mode: "open" });

          // Get attributes
          const sectionId = this.getAttribute("section-id") || "default";
          let badgeUrl = this.getAttribute("badge-url") || "";
          const rewardsBadgeUrl = this.getAttribute("rewards-badge-url") || "";
          const badgeText = this.getAttribute("badge-text") || "";
          const isFreeGift = this.getAttribute("is-free-gift") === "true";
          const savedLoyalty = localStorage.getItem("_tcloyalty");
          const savedDiscount = localStorage.getItem("_tcdiscount");
          const loyaltyAppInstalled =
            typeof window.loyaltyGlobalStyles !== "undefined";

          const showRewards =
            savedLoyalty !== "INACTIVE" ||
            !savedDiscount ||
            savedDiscount !== "GPSLT";
          if (isFreeGift && showRewards && loyaltyAppInstalled && rewardsBadgeUrl) {
            badgeUrl = rewardsBadgeUrl;
          }

          this.shadowRoot.innerHTML = `
                 <img width="60" height="60" src="${badgeUrl}" alt="${badgeText}">
            `;
        }
      },
    );
  }
}
